<template>
    <div id="menu" class="d-flex w-100 h-100 d-flex justify-content-between">

        <notify :storeIcon="logo" :active="notify[0]" :message="notify[1]" :type="notify[2]" :timeAuto="notify[3]" :buttonText="notify[4]" :returned="notify[5]" :auto="notify[6]" :toggle="notify[7]" :bolQuest="notify[8]" @closeNotify="toggleNotify()" @filterEventNotify="filterEventNotify"></notify>

        <div class="col-4 col-md-2 h-100 justify-content-start align-items-center d-flex position-relative py-0 ps-4">
            <img :src="a1" class="logoAPP" alt="">
            <div v-if="!notifications || !systemNotifications" class="errorNotifications" @click="settings()"><img :src="a20"></div> 
        </div>

        <div :class="isElectron ? 'col-xl-6' : 'col-xl-8'" class="col-8 col-md-8 h-100 d-flex align-items-center aling-content-center justify-content-end py-0 pe-4">
            <div @click="toCentral()" id="hMenu"  class="w-auto h-100 d-flex align-items-center aling-content-center justify-content-end">
                <img :src="a23">
            </div>
        </div>
        
    </div>

</template>
<script>

import Notify from '@/components/modal/modalType/NotificationModal.vue'

export default {
    name: "Menu",
    emits: ['toRoute', 'logout', 'electronPass', 'passingData', 'verify'],
    props:{
        printer: {
            default: {},
            type: Object
        },
        verifyChanges:{
            default: false,
            type: Boolean
        },
        catchResponseWS:{ //cadenas indicadoras del dia a listar
            default: () => ({destiny:null,message:"",status:false,for:""}),
            type: Object,
        },
        catchResponseElectron:{ 
            default: () => ({destiny:null,payload:{},reload:false}),
            type: Object,
        },
        config:{
            default:{},
            type: Object
        },
    },
    components:{
        Notify,
    },
    watch:{
        catchResponseWS(){ //escuchar respuestas de websocket
            if (this.catchResponseWS.destiny.includes(this.$options.name)) {

                switch(this.catchResponseWS.origin){
                    case "deliveryNotifications": 
                        switch(this.catchResponseWS.for){
                            case "on":
                                this.notifications = true;
                                break;
                            case "off":
                                this.notifications = false;
                                break;
                            default:
                                break;
                        }
                        break;
                }
                
            }
        },
    },
    data() {
        return{
            openedConf:false,
            a1: require('@/assets/images/a1-2.png'),
            a20: require('@/assets/images/a20.png'),
            a23: require('@/assets/images/a23.svg'),

            notifications:true, //se habilita al loguearse con websocket
            systemNotifications: localStorage.systemNotificationsOff ? false : true, //comprobacion de cordova
            returnCentral: (this.$route.name != 'orderTables') ? true : false,

            notify: [false, "Mensaje", "warning", 5, "Entendido", [""], true, true, false],
            logo: this.config.logoAPP,
            menuOpen: false,
            closeHelper:[]
        }
    },
    methods: {

        settings(){
            if(this.isCordova){
                cordova.plugins.diagnostic.switchToSettings();
            }
        },

        filterEventNotify(returned){
            this.notify[0] = false
			if(returned == "closeMenu"){
				this.$emit('toRoute', this.closeHelper[0], this.closeHelper[1]);
			}else if(returned == "backLog"){
                this.returnBack();
            }
        },

        toggleNotify(returned){
            this.notify[0] = false
			if(returned == "closeMenu"){
				this.$emit('toRoute', this.closeHelper[0], this.closeHelper[1]);
			}else if(returned == "backLog"){
                this.returnBack();
            }
        },

        toCentral(view){
            if(this.$route.name != view){
                this.$emit('toRoute', {trans:'imerse', destiny:'/'}, "replace");
            }
        },

        returnBack(){
            if(this.$route.name == 'menuOrder'){
                this.$emit('toRoute', {trans:'imerse', destiny:'orderTables'}, "replace");
            }else{
                this.$emit('logout');
            }
        }
    },
};
</script>
<style type="text/css" scoped>
    #menu{
        position: sticky;
        top: 0px;
        user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }
    #menu img.logoAPP{
        height: 50%;
        pointer-events: none;
        object-fit: contain;
        image-rendering: high-quality;
    }

    .errorNotifications{
        position:absolute;
        pointer-events:none;
        right:0;
        top:15%;
        height:70%;
        padding-right:25%;
        width:100%;
        display:flex;
        justify-content:flex-end;
        align-items:center;
    }

    .errorNotifications img{
        object-fit:cover;
        height:80%;
        margin-top:5px;
    }
    #hMenu{
        cursor: pointer;
    }
    #hMenu:hover img, #hMenu:hover svg{
        transform: scale(1.1);
    }
    #hMenu:active img, #hMenu:active svg{
        transform: scale(0.9);
    }

    #hMenu img, #hMenu svg{
        height: 40%;
        pointer-events: none;
    }
</style>